import { ReactNode, ReactElement } from 'react';
import { css as emotionCSS } from '@emotion/react';
import type { Theme } from '@mildang/mui';
import { Typography as Typography } from '@mildang/mui';

const rootStyle = (theme: Theme) => emotionCSS`
  display: grid;
  grid-template-columns: min-content auto;
  gap: 8px;
  align-items: center;
`;
const iconStyle = (theme: Theme) => emotionCSS`
  line-height: 1em;
  height: 18px;
  & svg {
    font-size: 18px;
  }
  color: white;
`;

export interface FooterIconValueInfoProps {
  label: ReactNode;
  icon: ReactElement;
}

const FooterIconValueInfo = (props: FooterIconValueInfoProps) => {
  const { label, icon } = props;

  return (
    <div css={rootStyle}>
      <span css={iconStyle}>{icon}</span>
      <Typography color="white" variant="body4">
        {label}
      </Typography>
    </div>
  );
};

export default FooterIconValueInfo;
